import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" />;
  }

  try {
    // Decode the token to get user information including role
    const decoded = jwtDecode(token);
    const userRole = decoded.role;

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" />;
    }

    return children;
  } catch (error) {
    // If token is invalid or expired
    localStorage.removeItem("token");
    localStorage.removeItem("userRole"); // Remove this for cleanup
    return <Navigate to="/login" />;
  }
};

export default ProtectedRoute;
